import clsx from 'clsx';
import type * as React from 'react';

import { Description } from '../Description';
import { Heading } from '../Heading';
import { Image } from '../Image';
import { type IconDefinition, renderIcon } from '../util';
import { CardCheck } from './CardCheck';

export type CardToggleBasicProps = {
    title: React.ReactNode;
    description?: React.ReactNode;
    image?: string | { dark: string; light: string };
    leadingIcon?: IconDefinition;
    className?: string;
};

/**
 * Basic card toggle.
 */
export function CardToggleBasic(props: CardToggleBasicProps) {
    return (
        <div className={clsx('flex items-center gap-4 rounded-md p-4', props.className)}>
            {props.image ? <Image aria-hidden src={props.image} width={40} height={40} /> : null}
            {props.title ? (
                <div className="flex gap-3">
                    {props.leadingIcon
                        ? renderIcon(props.leadingIcon, {
                              className: 'shrink-0 size-4.5 text-muted',
                          })
                        : null}

                    <div>
                        <Heading>{props.title}</Heading>
                        {props.description ? <Description>{props.description}</Description> : null}
                    </div>
                </div>
            ) : null}
            <CardCheck className="ml-auto" />
        </div>
    );
}
